module.exports = __webpack_public_path__ + "static/favicon-32x32-e0078ee103f79f1dfc90d2e6db19130c.png";